import { render, staticRenderFns } from "./authBtn.vue?vue&type=template&id=59bb4a52&scoped=true&"
import script from "./authBtn.vue?vue&type=script&lang=js&"
export * from "./authBtn.vue?vue&type=script&lang=js&"
import style0 from "./authBtn.vue?vue&type=style&index=0&id=59bb4a52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb4a52",
  null
  
)

export default component.exports